import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'इस पेज की रिपोर्ट करें',
  title: 'इस पेज में किसी समस्या की रिपोर्ट करें',
  reasons: {
    'inaccurate-or-fabricated': 'गलत या मनगढ़ंत जानकारी',
    'wrong-product': 'उत्पाद पेज से मेल नहीं खाते',
    'sexually-explicit': 'अश्लील यौन सामग्री',
    'regulated-product': 'प्रिस्क्रिप्शन वाला या नियंत्रित उत्पाद',
    'dangerous-product': 'खतरनाक उत्पाद',
    'ip-infringement': 'मेरे अधिकारों का उल्लंघन (ट्रेडमार्क/कॉपीराइट)',
    other: 'कुछ और',
  },
  detail: 'विवरण (वैकल्पिक)',
  submit: 'रिपोर्ट भेजें',
  cancel: 'रद्द करें',
  sent: 'धन्यवाद। हम 24 घंटों के भीतर रिपोर्ट की समीक्षा करते हैं।',
  failed: 'रिपोर्ट नहीं भेजी जा सकी। कृपया फिर से कोशिश करें।',
};
